export default __webpack_public_path__ + "static/media/esel2.b74508bf.png";